import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Loader2, UserPlus } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function ClientPicker({ open, onClose, onPick }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setBusy(true);
    const t = setTimeout(() => {
      (q.trim().length >= 2 ? api.get("/anagrafiche/search", { params: { q } }) : api.get("/anagrafiche"))
        .then(({ data }) => setRes((data || []).slice(0, 8))).catch(() => setRes([])).finally(() => setBusy(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="trattativa-client-picker">
        <DialogHeader>
          <DialogTitle className="font-heading text-forest">Per quale cliente è la trattativa?</DialogTitle>
          <DialogDescription>Scegli il cliente: tutti i prodotti che aggiungi saranno proposti a lui.</DialogDescription>
        </DialogHeader>
        <div className="relative"><Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, codice fiscale o P.IVA" className="pl-9" data-testid="trattativa-client-search" /></div>
        <div className="max-h-72 space-y-1 overflow-y-auto">
          {busy && <Loader2 className="mx-auto my-4 h-5 w-5 animate-spin text-forest" />}
          {!busy && res.length === 0 && <p className="py-4 text-center text-sm text-muted-foreground">Nessun cliente trovato.</p>}
          {!busy && res.map((a) => (
            <button key={a.id} onClick={() => onPick({ id: a.id, nome: a.ragione_sociale })} data-testid={`trattativa-client-${a.id}`}
              className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left hover:bg-sage">
              <span className="text-sm font-medium text-forest">{a.ragione_sociale}</span>
              <span className="text-xs text-muted-foreground">{a.partita_iva || a.codice_fiscale}</span>
            </button>
          ))}
        </div>
        <Link to="/pratica/nuova" onClick={onClose} data-testid="trattativa-new-client" className="flex items-center gap-2 text-sm font-semibold text-terracotta"><UserPlus className="h-4 w-4" /> Cliente nuovo: crea l'anagrafica</Link>
      </DialogContent>
    </Dialog>
  );
}

export function AskAnother({ label, onYes, onNo }) {
  return (
    <div className="fixed inset-0 z-[60] grid place-items-center bg-forest/40 p-4 backdrop-blur-sm" data-testid="trattativa-ask">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl animate-in zoom-in-95">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-terracotta/10"><Plus className="h-6 w-6 text-terracotta" /></div>
        <div className="mt-4 font-heading text-lg font-semibold text-forest">«{label}» aggiunto alla trattativa</div>
        <p className="mt-1 text-sm text-muted-foreground">Vuoi aggiungere un'altra proposta per lo stesso cliente?</p>
        <div className="mt-5 grid grid-cols-2 gap-2">
          <button onClick={onYes} data-testid="trattativa-ask-yes" className="rounded-lg bg-terracotta py-2.5 text-sm font-semibold text-white hover:bg-terracotta-hover">Sì, continua</button>
          <button onClick={onNo} data-testid="trattativa-ask-no" className="rounded-lg border py-2.5 text-sm font-semibold text-forest">No, vai alla trattativa</button>
        </div>
      </div>
    </div>
  );
}

